import * as propTypes from 'lib/prop_types';

export const routerPropsShape = {
  history: propTypes.object.isRequired,
  location: propTypes.object.isRequired,
  match: propTypes.object.isRequired,
};
